import React, {useEffect, useRef, useState} from 'react';
import Button from "@material-ui/core/Button";
import {Dialog, DialogActions, DialogContent, makeStyles, Tab, Tabs} from "@material-ui/core";
import {uid} from "react-uid";
import {useSelector} from "react-redux";
import listRequestWrapper from "../../../../../../../../../Services/API/listRequestWrapper";
import QuillTextEditor from "../../../../../../../../../Utils/QuillTextEditor/QuillTextEditor";

const useStyles = makeStyles(() => ({
    paperFullWidth: {
        height: '100%',
        padding: 0,
    },
    dialogContentRoot: {
        padding: 0,
        '&:first-child': {
            paddingTop: 0
        }

    }
}));
export const OpenTextEditor = ({openTextEditor}) => {
    return (
        <Button
            style={{textAlign: "center", marginTop: 10}}
            variant={"contained"}
            color={"primary"}
            onClick={openTextEditor}
            fullWidth
        >
            Open Text Editor
        </Button>
    )
};

export const TextEditor = ({open, onClose, value, apply}) => {
    const quillRef = useRef(null)
    const userLanguage = useSelector(state => state.app.userLanguage);
    const classes = useStyles();
    const [text, setText] = useState('');
    const [selectedTab, setSelectedTab] = useState('');
    const [languages, setLanguages] = useState([])
    useEffect(() => {
        setText(typeof value === 'object' ? value : typeof value === 'string' ? {[userLanguage]: value} : "")
    }, [value, userLanguage]);

    useEffect(() => {
        getLanguages();
    }, [])

    useEffect(() => {
        if (!userLanguage) {
            setSelectedTab('en')
        }
        setSelectedTab(userLanguage)
    }, [userLanguage])

    async function getLanguages() {
        try {
            const languages = await listRequestWrapper('language');
            setLanguages(languages)
        } catch (e) {
            console.log(e)
        }
    }

    function onApply() {
        if (quillRef.current) {
            const newTxt = quillRef.current.getEditorContents();
            apply({...text, [selectedTab]: newTxt})
        }
    }

    function onChangeTabs(v) {
        const text = quillRef.current.getEditorContents();
        setText(prev => {
            return {
                ...prev,
                [selectedTab]: text
            }
        })
        setSelectedTab(v)
    }

    return (
        <Dialog open={open} onClose={onClose} classes={{paperFullWidth: classes.paperFullWidth}} fullWidth={true}
                maxWidth={false}>
            <DialogContent classes={{root: classes.dialogContentRoot}}>
                <div style={{
                    display: 'flex',
                    height: '100%',
                    padding: 0
                }}>
                    <Tabs orientation={'vertical'} value={selectedTab} onChange={(e, v) => onChangeTabs(v)}>
                        {languages.map(lng => {
                            return <Tab
                                key={uid(lng)}
                                value={lng.id}
                                label={lng.name}
                                style={{
                                    //minHeight: 30
                                }}
                            />
                        })}
                    </Tabs>
                    <div style={{width: '100%'}}>
                        <QuillTextEditor
                            value={text[selectedTab] || ''}
                            ref={quillRef}
                            preserveWhitespace={true}
                        />
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <Button size={"small"} variant={"contained"} color={"primary"} onClick={onApply}>Apply</Button>
                <Button size={"small"} variant={"contained"} color={"default"} onClick={onClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
    )
};